module.exports = __webpack_public_path__ + "img/ecologic.a0f38edb.png";